import clsx from 'clsx'
import { useCallback, useState, type ReactNode } from 'react'
import YouTube from 'react-youtube'

import { Image } from '@/src/elements/image'
import { ICON } from '@/src/general/enums/icons'

import { Icon } from '../../media/Icon'
import { Card } from '../Card'
import { CardBody } from '../CardBody'
import type { TYoutubeCardProps } from './YoutubeCard.type'

const YOUTUBE_IFRAME_OPTIONS = {
  height: '100%',
  width: '100%',
  playerVars: {
    autoplay: 1,
    controls: 1,
    modestbranding: 1,
    rel: 0,
    showinfo: 0,
  },
}

export const YoutubeCard = ({ classNames, youtubeId, ...otherProps }: TYoutubeCardProps): ReactNode => {
  const [isYoutubeDisplayed, setIsYoutubeDisplayed] = useState(false)

  const handlePress = useCallback(() => {
    setIsYoutubeDisplayed(true)
  }, [])

  return (
    <Card
      classNames={{
        base: clsx('bg-black w-full', classNames?.base),
        body: clsx('px-4 py-3', classNames?.body),
      }}
      radius="lg"
      isPressable
      onPress={handlePress}
      {...otherProps}
    >
      <CardBody className="group relative flex aspect-video w-full flex-row items-center justify-center">
        {!!isYoutubeDisplayed && (
          <YouTube
            className={clsx('absolute h-full w-full transition-all')}
            videoId={youtubeId}
            opts={YOUTUBE_IFRAME_OPTIONS}
            onPlay={() => setIsYoutubeDisplayed(true)}
          />
        )}

        {!isYoutubeDisplayed && (
          <>
            <Image
              alt="youtube thumbnail"
              contentFit="cover"
              className={clsx('absolute transition-all', !isYoutubeDisplayed ? 'opacity-80' : 'opacity-0')}
              source={`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`}
            />
            <Icon
              className="absolute h-20 w-20 text-white opacity-90 group-hover:opacity-70"
              size="xl"
              name={ICON.YOUTUBE}
            />
          </>
        )}
      </CardBody>
    </Card>
  )
}
